import Leaflet from 'leaflet';

declare global {
  interface Window {
    L: typeof Leaflet;
  }
}

window.L = Leaflet;
